import React from 'react';

import Button from '../../components/Button';
import FooterWrapper from '../../components/FooterWrapper';

import HeadTitle from '../../components/HeadTitle';
import { Card } from './components/Card';
import { EligibilityPlanProps } from '../../contexts/PaymentContext';
import * as S from './styles';

const EligibilityDefaultIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/helth-plan.svg';

export type PaymentViewTemplateProps = {
  eligibilityPlans: EligibilityPlanProps[];
  handleSelectPayment: (payment: EligibilityPlanProps) => void;
  handleSelectedPayment: (payment: EligibilityPlanProps) => void;

  buttonDisable?: boolean;
};
export const PaymentViewTemplate = ({
  eligibilityPlans,
  handleSelectPayment,
  handleSelectedPayment,
  buttonDisable
}: PaymentViewTemplateProps) => {
  const [payment, setPayment] = React.useState<EligibilityPlanProps | undefined>();

  const handleContinue = () => {
    if (payment) handleSelectedPayment(payment);
  };

  const handleDisabledButton = () => {
    if (payment?.cod_plano) return false;
    return true;
  };

  const selectPayment = (eligibility: EligibilityPlanProps) => {
    setPayment(eligibility);
    handleSelectPayment(eligibility);
  };

  return (
    <S.Container>
      <S.PaymentMethodContainer>
        <HeadTitle title="Escolha a forma de pagamento" />
        <S.CardWrapper>
          <S.TitleSection>Planos cadastrados</S.TitleSection>
          {eligibilityPlans.map((plan, index) => (
            <Card
              key={index}
              icon={plan.image ? plan.image : EligibilityDefaultIcon}
              title={plan.nome}
              onClick={() => selectPayment(plan)}
              checked={payment?.cod_plano === plan?.cod_plano}
            />
          ))}
        </S.CardWrapper>
      </S.PaymentMethodContainer>
      <FooterWrapper>
        <Button disabled={handleDisabledButton() || buttonDisable} title="Continuar" onClick={handleContinue} />
      </FooterWrapper>
    </S.Container>
  );
};
